import React, { useState } from 'react';
import { Globe, Bell, Shield, CreditCard, Mail, Server, Key, Database, Smartphone, CheckCircle2, Save, Plus, Trash2, Edit2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
interface AdminSettingsFullManagerProps {
  success: (msg: string) => void;
}
export function AdminSettingsFullManager({
  success
}: AdminSettingsFullManagerProps) {
  const [notifSettings, setNotifSettings] = useState<Record<string, boolean>>({
    newOrders: true,
    newAstrologers: true,
    pushNotifications: false,
    weeklyDigest: true,
    systemErrors: true,
    paymentFailures: true
  });
  const [paymentSystems, setPaymentSystems] = useState([{
    name: 'Stripe',
    status: true,
    fee: '2.9% + 30¢'
  }, {
    name: 'PayPal',
    status: true,
    fee: '3.49% + 49¢'
  }, {
    name: 'CloudPayments',
    status: false,
    fee: '2.8%'
  }, {
    name: 'Crypto (USDT)',
    status: true,
    fee: '1%'
  }]);
  const [services, setServices] = useState([{
    id: 'SRV-001',
    name: 'Натальная карта (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 490 ₽',
    status: 'active'
  }, {
    id: 'SRV-002',
    name: 'Соляр на год (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 990 ₽',
    status: 'active'
  }, {
    id: 'SRV-003',
    name: 'Консультация (30 мин)',
    category: 'Консультации',
    type: 'Видео',
    price: 'от 3 000 ₽',
    status: 'active'
  }, {
    id: 'SRV-004',
    name: 'Базовый курс астрологии',
    category: 'Курсы',
    type: 'Видеокурс',
    price: '15 000 ₽',
    status: 'active'
  }]);
  const handleSave = () => {
    success('Настройки успешно сохранены');
  };
  const renderToggle = (label: string, checked: boolean, onChange: () => void, description?: string) => <div className="flex items-start justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-7013">
      <div data-id="element-7014">
        <div className="text-sm font-medium text-slate-900" data-id="element-7015">{label}</div>
        {description && <div className="text-xs text-slate-500 mt-0.5" data-id="element-7016">{description}</div>}
      </div>
      <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ml-4 ${checked ? 'bg-indigo-500' : 'bg-slate-300'}`} onClick={onChange} data-id="element-7017">
        <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${checked ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-7018" />
      </button>
    </div>;
  const generalSettings = <div className="space-y-6 max-w-3xl" data-id="element-7019">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7020">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7021">
          <Globe className="w-4 h-4 text-indigo-500" data-id="element-7022" /> Основная информация
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-7023">
          <Input label="Название платформы" defaultValue="Astriqo" data-id="element-7024" />
          <Input label="Основной домен" defaultValue="astriqo.com" data-id="element-7025" />
          <Input label="Email поддержки" defaultValue="support@astriqo.com" data-id="element-7026" />
          <Input label="Телефон поддержки" defaultValue="+7 (800) 555-35-35" data-id="element-7027" />
          <div className="md:col-span-2" data-id="element-7028">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-7029">
              Язык по умолчанию
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-7030">
              <option value="ru" data-id="element-7031">Русский (RU)</option>
              <option value="en" data-id="element-7032">English (EN)</option>
              <option value="es" data-id="element-7033">Español (ES)</option>
            </select>
          </div>
        </div>
      </Card>

      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7034">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7035">
          <Database className="w-4 h-4 text-indigo-500" data-id="element-7036" /> Локализация и форматы
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-7037">
          <div data-id="element-7038">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-7039">
              Основная валюта
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-7040">
              <option value="RUB" data-id="element-7041">Российский рубль (₽)</option>
              <option value="USD" data-id="element-7042">Доллар США ($)</option>
              <option value="EUR" data-id="element-7043">Евро (€)</option>
            </select>
          </div>
          <div data-id="element-7044">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-7045">
              Часовой пояс сервера
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-7046">
              <option value="Europe/Moscow" data-id="element-7047">Europe/Moscow (UTC+3)</option>
              <option value="UTC" data-id="element-7048">UTC</option>
            </select>
          </div>
        </div>
      </Card>

      <div className="flex justify-end" data-id="element-7049">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-7051" />} onClick={handleSave} data-id="element-7050">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const servicesSettings = <div className="space-y-6" data-id="element-7052">
      <div className="flex justify-between items-center" data-id="element-7053">
        <h3 className="text-sm font-bold text-slate-900" data-id="element-7054">
          Управление услугами
        </h3>
        <Button variant="primary" size="sm" icon={<Plus className="w-4 h-4" data-id="element-7056" />} data-id="element-7055">
          Добавить услугу
        </Button>
      </div>

      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-7057">
        <table className="w-full text-left" data-id="element-7058">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-7059">
            <tr data-id="element-7060">
              <th className="px-4 py-3 font-medium" data-id="element-7061">ID</th>
              <th className="px-4 py-3 font-medium" data-id="element-7062">Название</th>
              <th className="px-4 py-3 font-medium" data-id="element-7063">Категория</th>
              <th className="px-4 py-3 font-medium" data-id="element-7064">Тип</th>
              <th className="px-4 py-3 font-medium" data-id="element-7065">Базовая цена</th>
              <th className="px-4 py-3 font-medium" data-id="element-7066">Статус</th>
              <th className="px-4 py-3 text-right font-medium" data-id="element-7067">Действия</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-7068">
            {services.map(s => <tr key={s.id} className="hover:bg-slate-50" data-id="element-7069">
                <td className="px-4 py-3 text-xs text-slate-500" data-id="element-7070">{s.id}</td>
                <td className="px-4 py-3 text-sm font-medium text-slate-900" data-id="element-7071">
                  {s.name}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-7072">
                  {s.category}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-7073">{s.type}</td>
                <td className="px-4 py-3 text-sm font-bold text-slate-900" data-id="element-7074">
                  {s.price}
                </td>
                <td className="px-4 py-3" data-id="element-7075">
                  <Badge variant={s.status === 'active' ? 'success' : 'neutral'} size="sm" data-id="element-7076">
                    {s.status === 'active' ? 'Активна' : 'Скрыта'}
                  </Badge>
                </td>
                <td className="px-4 py-3 text-right" data-id="element-7077">
                  <div className="flex justify-end gap-2" data-id="element-7078">
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Edit2 className="w-4 h-4 text-slate-400" data-id="element-7080" />} data-id="element-7079" />
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Trash2 className="w-4 h-4 text-rose-400" data-id="element-7082" />} data-id="element-7081" />
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </Card>
    </div>;
  const paymentSettings = <div className="space-y-6 max-w-4xl" data-id="element-7083">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7084">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7085">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7086">
            <CreditCard className="w-4 h-4 text-indigo-500" data-id="element-7087" /> Платёжные шлюзы
          </h3>
          <div className="space-y-1" data-id="element-7088">
            {paymentSystems.map((p, i) => <div key={i} className="flex items-center justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-7089">
                <div data-id="element-7090">
                  <div className="text-sm font-medium text-slate-900" data-id="element-7091">
                    {p.name}
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-7092">
                    Комиссия: {p.fee}
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-7093">
                  <Button variant="ghost" size="sm" className="text-xs h-7" data-id="element-7094">
                    Настроить
                  </Button>
                  <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ${p.status ? 'bg-emerald-500' : 'bg-slate-300'}`} onClick={() => {
                const newSystems = [...paymentSystems];
                newSystems[i].status = !newSystems[i].status;
                setPaymentSystems(newSystems);
                success(newSystems[i].status ? `${p.name} включен` : `${p.name} отключен`);
              }} data-id="element-7095">
                    <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${p.status ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-7096" />
                  </button>
                </div>
              </div>)}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7097">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7098">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-7099" /> Финансовые настройки
          </h3>
          <div className="space-y-4" data-id="element-7100">
            <Input label="Базовая комиссия платформы (%)" defaultValue="20" data-id="element-7101" />
            <Input label="Минимальная сумма вывода (₽)" defaultValue="5000" data-id="element-7102" />
            <Input label="Период холда средств (дней)" defaultValue="14" data-id="element-7103" />

            <div className="pt-4 border-t border-slate-100" data-id="element-7104">
              {renderToggle('Автоматические выплаты', false, () => {}, 'Выплаты астрологам 1 и 15 числа месяца')}
              {renderToggle('Разрешить возвраты клиентам', true, () => {}, 'В течение 24 часов после оплаты')}
            </div>
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-7105">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-7107" />} onClick={handleSave} data-id="element-7106">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const emailSettings = <div className="space-y-6 max-w-4xl" data-id="element-7108">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7109">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7110">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7111">
            <Mail className="w-4 h-4 text-indigo-500" data-id="element-7112" /> SMTP Настройки
          </h3>
          <div className="space-y-4" data-id="element-7113">
            <Input label="SMTP Сервер" defaultValue="smtp.sendgrid.net" data-id="element-7114" />
            <div className="grid grid-cols-2 gap-4" data-id="element-7115">
              <Input label="Порт" defaultValue="587" data-id="element-7116" />
              <div data-id="element-7117">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-7118">
                  Шифрование
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-7119">
                  <option value="tls" data-id="element-7120">TLS</option>
                  <option value="ssl" data-id="element-7121">SSL</option>
                  <option value="none" data-id="element-7122">Нет</option>
                </select>
              </div>
            </div>
            <Input label="SMTP Логин" defaultValue="apikey" data-id="element-7123" />
            <Input label="SMTP Пароль" type="password" defaultValue="****************" data-id="element-7124" />
            <Input label="Отправитель (From Email)" defaultValue="noreply@astriqo.com" data-id="element-7125" />
            <Input label="Имя отправителя (From Name)" defaultValue="Astriqo" data-id="element-7126" />
            <Button variant="outline" size="sm" className="w-full mt-2" data-id="element-7127">
              Отправить тестовое письмо
            </Button>
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7128">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7129">
            <Bell className="w-4 h-4 text-indigo-500" data-id="element-7130" /> Системные уведомления
          </h3>
          <div className="space-y-1" data-id="element-7131">
            {renderToggle('Уведомления о новых заказах', notifSettings.newOrders, () => setNotifSettings(p => ({
            ...p,
            newOrders: !p.newOrders
          })))}
            {renderToggle('Заявки на верификацию', notifSettings.newAstrologers, () => setNotifSettings(p => ({
            ...p,
            newAstrologers: !p.newAstrologers
          })))}
            {renderToggle('Ошибки системы (Критичные)', notifSettings.systemErrors, () => setNotifSettings(p => ({
            ...p,
            systemErrors: !p.systemErrors
          })))}
            {renderToggle('Ошибки платежей', notifSettings.paymentFailures, () => setNotifSettings(p => ({
            ...p,
            paymentFailures: !p.paymentFailures
          })))}
            {renderToggle('Еженедельный дайджест', notifSettings.weeklyDigest, () => setNotifSettings(p => ({
            ...p,
            weeklyDigest: !p.weeklyDigest
          })))}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-7132">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-7134" />} onClick={handleSave} data-id="element-7133">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const securitySettings = <div className="space-y-6 max-w-4xl" data-id="element-7135">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7136">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7137">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7138">
            <Shield className="w-4 h-4 text-indigo-500" data-id="element-7139" /> Политики безопасности
          </h3>
          <div className="space-y-1" data-id="element-7140">
            {renderToggle('Двухфакторная авторизация (2FA)', true, () => {}, 'Обязательно для всех администраторов')}
            {renderToggle('Логирование всех входов', true, () => {}, 'Сохранять IP и User-Agent')}
            {renderToggle('Защита от брутфорса', true, () => {}, 'Блокировка после 5 неудачных попыток')}
            {renderToggle('Принудительная смена пароля', false, () => {}, 'Каждые 90 дней')}
            {renderToggle('Ограничение сессий', true, () => {}, 'Не более 3 активных сессий на пользователя')}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7141">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7142">
            <Key className="w-4 h-4 text-indigo-500" data-id="element-7143" /> Ограничения доступа (IP)
          </h3>
          <div className="space-y-4" data-id="element-7144">
            <div data-id="element-7145">
              <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-7146">
                Белый список IP для админки
              </label>
              <textarea className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500 min-h-[100px]" placeholder="Введите IP адреса по одному в строке..." defaultValue="192.168.1.1&#10;10.0.0.0/24" data-id="element-7147" />
              <p className="text-[10px] text-slate-500 mt-1" data-id="element-7148">
                Оставьте пустым для доступа с любого IP
              </p>
            </div>
            {renderToggle('Блокировать Tor/VPN', false, () => {})}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-7149">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-7151" />} onClick={handleSave} data-id="element-7150">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const apiSettings = <div className="space-y-6 max-w-4xl" data-id="element-7152">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7153">
        <div className="flex justify-between items-center mb-4" data-id="element-7154">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2" data-id="element-7155">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-7156" /> API Ключи
          </h3>
          <Button variant="outline" size="sm" icon={<Plus className="w-4 h-4" data-id="element-7158" />} data-id="element-7157">
            Создать ключ
          </Button>
        </div>

        <div className="space-y-4" data-id="element-7159">
          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-7160">
            <div className="flex justify-between items-start mb-2" data-id="element-7161">
              <div data-id="element-7162">
                <div className="text-sm font-bold text-slate-900" data-id="element-7163">
                  Mobile App API (Production)
                </div>
                <div className="text-xs text-slate-500" data-id="element-7164">
                  Создан: 12.05.2023 • Последнее использование: 5 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-7165">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-7166">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-7167">
                sk_live_51Mxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-7168">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-7169">
                <Trash2 className="w-4 h-4" data-id="element-7170" />
              </Button>
            </div>
          </div>

          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-7171">
            <div className="flex justify-between items-start mb-2" data-id="element-7172">
              <div data-id="element-7173">
                <div className="text-sm font-bold text-slate-900" data-id="element-7174">
                  OpenAI Integration Key
                </div>
                <div className="text-xs text-slate-500" data-id="element-7175">
                  Создан: 01.08.2023 • Последнее использование: 1 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-7176">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-7177">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-7178">
                sk-proj-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-7179">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-7180">
                <Trash2 className="w-4 h-4" data-id="element-7181" />
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>;
  return <div className="space-y-6" data-id="element-7182">
      <div data-id="element-7183">
        <h2 className="text-xl font-bold text-slate-900" data-id="element-7184">
          Настройки платформы
        </h2>
        <p className="text-sm text-slate-500" data-id="element-7185">
          Глобальные параметры работы системы
        </p>
      </div>

      <Tabs tabs={[{
      id: 'general',
      label: 'Общие',
      content: generalSettings
    }, {
      id: 'services',
      label: 'Услуги',
      content: servicesSettings
    }, {
      id: 'payments',
      label: 'Платежи',
      content: paymentSettings
    }, {
      id: 'email',
      label: 'Email',
      content: emailSettings
    }, {
      id: 'security',
      label: 'Безопасность',
      content: securitySettings
    }, {
      id: 'api',
      label: 'API',
      content: apiSettings
    }]} data-id="element-7186" />
    </div>;
}